import blog3 from "../assets/media/0x0.webp";

import blog2 from "../assets/media/com-eckerling-haroses-aaron-drizzle.jpg";
import blog1 from "../assets/media/300x300bb.webp";
export const blogs = [
  {
    id: 1,
    author: "Mark Hass",
    Date: "Mar 28, 2024",
    image:
      "https://dnh-web-static.s3.us-west-1.amazonaws.com/mark_edited_912f855fa2.png",
    title: "Building Better Innovation",
    description:
      "Mark Haas is the CEO of the Helmsman Group, a company that has helped companies like Magic Spoon, Urban Remedy, Kellogg’s, and Haven’s …",
    link: "https://open.spotify.com/episode/3CIPEdwundbjKEFLv0dLZS?si=5rx_UgDlQ5exuq5aggtCWQ&nd=1&dlsi=18ce1a897db14267",
    tags: ["Celebrity endorsements", "Endorsement Deals"],
  },
  {
    id: 2,
    author: "PodcastiHeartPodcasts",
    Date: "April 2, 2024",
    image: blog1,
    title: "The Dark Side of Celebrity Endorsements",
    description:
      "As celebrities bask in their own fame, they are frequently offered exceptionally lucrative endorsement deals, often worth obscene…",
    link: "https://open.spotify.com/episode/4k5LaB5OkcdivHqusC6pn6?si=7nCVbKJhTb-w3W16XMbTqw&nd=1&dlsi=50a3618189574d5c",
    tags: ["Celebrity Culture", "Brand Partnerships", "Endorsement Ethics"],
  },
  {
    id: 3,
    author: "Debra L. Eckerling",
    Date: "April 18, 2024",
    image: blog2,
    title: "Is Aaron’s Haroses the New Hummus?",
    description:
      "In the labyrinth of Silicon Valley’s venture capital landscape, serendipity often leads to profound revelations. In the year 2014, my path intersected with Amol Deshpande, a Partner at Kleiner, Perkins, Caulfield, Baker (KPCB), marking the genesis of a transformative journey. Amol’s focus at KPCB was centered on food business investments, and I found myself playing a pivotal role as an independent Subject Matter Expert advisor tasked with evaluating potential investments in the food sector.",
    link: "https://jewishjournal.com/community/370454/is-aarons-haroses-the-new-hummus/",
    tags: [
      "Food Innovation",
      "Venture Capital",
      "Silicon Valley",
      "Cultural Cuisine",
    ],
  },
  {
    id: 4,
    author: "Chloe Sorvino",
    Date: "Dec 12, 2023",
    image: blog3,
    title:
      "Exclusive: Mars Unveils Strategy To Double Snacking Revenue To $36 Billion",
    description:
      "Millions of Snickers, Milky Way, Three Musketeers and Twix bars roll off Mars conveyor belts on their way to holiday celebrations …",
    link: "https://www.forbes.com/sites/chloesorvino/2023/12/12/exclusive-mars-strategy-to-double-snacking-revenue-to-36-billion/",
    tags: ["CPG Strategy", "Confectionery", "Revenue Growth", "Mars Inc"],
  },
  {
    id: 4,
    author: "Chloe Sorvino",
    Date: "Dec 12, 2023",
    image:
      "https://regulatecpg.com/wp-content/uploads/2024/10/Blog4-1-300x188.png",
    title:
      "https://www.forbes.com/sites/chloesorvino/2023/12/12/exclusive-mars-strategy-to-double-snacking-revenue-to-36-billion/",
    description:
      "Millions of Snickers, Milky Way, Three Musketeers and Twix bars roll off Mars conveyor belts on their way to holiday celebrations …",
    link: "https://medium.com/@mark_37006/unveiling-regulate-an-innovative-product-lifecycle-platform-b3bdfde89600",
  },
  {
    id: 5,
    author: "Duncan Alney",
    Date: "Dec 8, 2023",
    image:
      "https://regulatecpg.com/wp-content/uploads/2024/10/Blog5-1-300x188.png",
    title: "Mark Haas: Navigating The CPG Industry",
    description:
      "Are you an aspiring or an existing entrepreneur struggling to grow your CPG brand? Do you need help identifying the potential risks..",
    link: "https://firebellymarketing.com/podcast/mark-haas/",
  },

  {
    id: 6,
    author: "LinkedIn",
    Date: "Dec 22, 2021",
    image:
      "https://regulatecpg.com/wp-content/uploads/2024/10/Blog6-1-300x188.png",
    title: "Not Your Grandmother’s Sugar: New Players in the Sucrose Game",
    description:
      "Sugar is the proverbial double-edged sword. Sugar, or sucrose, tastes delicious and offers both sweetness and functionality to a plethora of …",
    link: "https://www.linkedin.com/pulse/your-grandmothers-sugar-new-players-sucrose-game-helmsmangroup/?published=t",
  },
];
